import AjaxBuilder from "../../../Common/AjaxBuilder";
import { Util } from "../../../Common/Util";

export class Comments {
    constructor({ page, infoPopup }) {
        this.$page = page;
        this._infoPopup = infoPopup;

        this.$commentForm = this.$page.find('#add-comment-form');
        this._route = this.$commentForm.attr('action');

        this._init();
    }

    _init() {
        $('input[name ="agent"]').val(navigator.userAgent);
        this.$commentForm.on('submit', this._formSubmit.bind(this));
    }

    _formSubmit(event) {
        event.preventDefault();

        const data = $('#add-comment-form').serializeArray().reduce(function (
            obj, item) {
            obj[item.name] = item.value;
            return obj;
        }, {});

        data.token = Util.token();

        new AjaxBuilder({
            route: this._route,
            data,
            token: Util.token(),
        }, 'POST').execute({
            success: this._formSubmitSuccess.bind(this),
            error: this._formSubmitError.bind(this),
        });
    }

    _formSubmitSuccess(data) {
        $(this.$commentForm)[0].reset();
        this._infoPopup.show({
            title: data.response.title,
            message: data.response.message,
        });
    }

    _formSubmitError(data) {
        console.log(data);
        this._infoPopup.show({
            title: data.responseJSON.response.title,
            message: data.responseJSON.response.message,
        });
    }

}